import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsFinanceProducts(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS_FINANCE_PRODUCTS,dtConfig[ModulesMap.REPORTS_FINANCE_PRODUCTS].getReportsFinanceProducts,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}

export default {
	getReportsFinanceProducts,
}
